import { render, staticRenderFns } from "./ProductVariantContentCreate.vue?vue&type=template&id=52ce9938&scoped=true&"
import script from "./ProductVariantContentCreate.vue?vue&type=script&lang=js&"
export * from "./ProductVariantContentCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantContentCreate.vue?vue&type=style&index=0&id=52ce9938&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ce9938",
  null
  
)

export default component.exports